import { PageHeader } from '@ant-design/pro-layout'
import { useSuspenseQuery } from '@apollo/client'
import { FetchBusinessDaysDocument } from '@salescore/client-api'
import { getOrganizationIdFromPath } from '@salescore/client-common'
import { BusinessDayCalendarForm } from '@salescore/client-feature-setting'
import { createFileRoute } from '@tanstack/react-router'
import type { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

const Page = (): ReactNode => {
  const {
    data: { businessDays },
    refetch,
  } = useSuspenseQuery(FetchBusinessDaysDocument, {
    variables: { organizationId: getOrganizationIdFromPath() },
    fetchPolicy: 'cache-and-network',
  })
  const { t } = useTranslation()

  return (
    <PageHeader title={t(`営業日設定`)}>
      <div className="mb-4">{t(`カレンダーの日をクリックすると、営業日が切り替わります。`)}</div>
      <BusinessDayCalendarForm
        businessDays={businessDays}
        refetch={async () => {
          await refetch()
        }}
      />
    </PageHeader>
  )
}

export const Route = createFileRoute('/o/$organizationId/v2/settings/business_day')({
  component: Page,
})
